import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpTopSearchesKeys = {
  all: ['analytics', 'fp-top-searches'] as const,
  list: (params?: AnalyticsQueryParams) => [...fpTopSearchesKeys.all, 'list', params] as const,
};

export const useFPTopSearchesData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpTopSearchesKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPTopSearches(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
